/* PDP: Swatch-Klick → Bestand neu laden (header-neutral, ohne jQuery-Zwang) */
(function () {
  var onReady = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  // nur auf Produktdetailseiten
  var isPdp = function () {
    return location.pathname.indexOf('/products/') !== -1;
  };

  // kleines Debounce, um Mehrfach-Reloads zu vermeiden
  var debounce = function (fn, wait) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, wait); };
  };

  onReady(function () {
    if (!isPdp()) return;

    // Swatch/Inputs beobachten – NICHT global auf Header klicken etc.
    var root = document.querySelector('.Product, .product, form[action*="/cart/add"]') || document;
    var handler = debounce(function () {
      // Wenn jQuery vorhanden ist, nutze bisherigen Weg – sonst graceful no-op
      if (window.jQuery && typeof window.jQuery.fn.load === 'function') {
        window.jQuery('#reload').load('#reload');
      } else {
        // Native Fallback: Teilbereich neu zeichnen, falls API vorhanden (optional)
        var el = document.getElementById('reload');
        if (el && el.dataset && el.dataset.src) {
          fetch(el.dataset.src).then(function (r) { return r.text(); }).then(function (html) { el.innerHTML = html; });
        }
      }
    }, 180);

    // Delegation: nur Inputs/Buttons innerhalb des Produktbereichs
    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t) return;
      if (t.matches('input, button, .swatch input, .product-form__input input')) handler();
    }, true);
  });

  /* center-pulse-Elemente NUR außerhalb der PDP entfernen (Kommentar/Logik konsistent) */
  onReady(function () {
    if (isPdp()) return; // auf PDPs NICHT entfernen
    document.querySelectorAll('.center-pulse').forEach(function (el) { el.remove(); });
  });
})();
